import TrashieContainerPublic from './TrashieContainerPublic';

export default TrashieContainerPublic;
